import { render, staticRenderFns } from "./CurrencyTransaction.vue?vue&type=template&id=47ac6356&scoped=true&"
import script from "./CurrencyTransaction.vue?vue&type=script&lang=js&"
export * from "./CurrencyTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac6356",
  null
  
)

export default component.exports